import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      content: {
        // path => locale => []
      },
    },
    mutations: {
      UPDATE_CONTENT(state, { path, data, locale }) {
        let pathContent = state.content[path] || {};
        state.content = {
          ...state.content,
          [path]: {
            ...pathContent,
            [locale]: {
              data,
              __updatedAt: Date.now()
            }
          }
        }
      }
    },
    actions: {
      FETCH_CONTENT({state, commit}, { path, locale }) {
        if (state.content[path]
          && state.content[path][locale]
          && state.content[path][locale].data
          && Date.now() - state.content[path][locale].__updatedAt < cachetime
        ) {
          return ;
        }

        return axios.get(encodeURI(`/api/more?p=${path}`))
          .then((res) => {
            const data = res.data || [];

            commit('UPDATE_CONTENT', { path, data, locale })
          }).catch(err => console.log(err));
      }
    },
    getters: {
      getContent: (state) => (path, locale) => {
        return (state.content[path]
          && state.content[path][locale]
          && state.content[path][locale].data
        ) || []
      }
    },
  }
}